"use strict";
/**
 * This code was AUTOGENERATED using the kinobi library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun kinobi to update it.
 *
 * @see https://github.com/metaplex-foundation/kinobi
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMetadataDelegateRoleSerializer = exports.MetadataDelegateRole = void 0;
const serializers_1 = require("@metaplex-foundation/umi/serializers");
var MetadataDelegateRole;
(function (MetadataDelegateRole) {
    MetadataDelegateRole[MetadataDelegateRole["AuthorityItem"] = 0] = "AuthorityItem";
    MetadataDelegateRole[MetadataDelegateRole["Collection"] = 1] = "Collection";
    MetadataDelegateRole[MetadataDelegateRole["Use"] = 2] = "Use";
    MetadataDelegateRole[MetadataDelegateRole["Data"] = 3] = "Data";
    MetadataDelegateRole[MetadataDelegateRole["ProgrammableConfig"] = 4] = "ProgrammableConfig";
    MetadataDelegateRole[MetadataDelegateRole["DataItem"] = 5] = "DataItem";
    MetadataDelegateRole[MetadataDelegateRole["CollectionItem"] = 6] = "CollectionItem";
    MetadataDelegateRole[MetadataDelegateRole["ProgrammableConfigItem"] = 7] = "ProgrammableConfigItem";
})(MetadataDelegateRole = exports.MetadataDelegateRole || (exports.MetadataDelegateRole = {}));
function getMetadataDelegateRoleSerializer() {
    return (0, serializers_1.scalarEnum)(MetadataDelegateRole, {
        description: 'MetadataDelegateRole',
    });
}
exports.getMetadataDelegateRoleSerializer = getMetadataDelegateRoleSerializer;
//# sourceMappingURL=metadataDelegateRole.js.map